<template>
  <div class="ibox float-e-margins">
    <user-header></user-header>
    <user-content></user-content>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from './Role/Header'
import Content from './Role/Content'

export default {
  computed: {
    ...mapGetters({
      userRoles: 'getUserRoles'
    }),
    role: ({ $route, $store }) => $store.state.userRoleList.find(r => r.id === parseInt($route.params.id)) || {}
  },
  components: {
    userHeader: Header,
    userContent: Content
  },
  mounted () {
    this.$store.state.userRoleList.length === 0 && this.$store.dispatch('loadUserRoles')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Role.vue